export enum PaymentMethodId {
    CREDIT_CARD = 'CREDIT_CARD',
    PAY_PAL = 'PayPal',
    GIFT_CARD = 'SVS_GIFT_CARD',
    APPLE_PAY = 'DW_APPLE_PAY',
    AFTER_PAY = 'AFTERPAY_PBI',
}
